/**
 * Turn heading text (which may contain inline HTML) into a stable, URL-safe id.
 * Used both by BlockHeading (to set an element id when the editor left the
 * anchor empty) and by the TableOfContents (to link to the same id), so the two
 * always agree.
 */
export const slugify = (input: string): string => {
	if (!input) return '';

	return input
		.replace(/<[^>]*>/g, '') // strip HTML tags
		.replace(/&[^;]+;/g, ' ') // strip HTML entities
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '') // strip diacritics
		.toLowerCase()
		.trim()
		.replace(/[^a-z0-9\s-]/g, '') // drop non-alphanumeric
		.replace(/[\s_-]+/g, '-') // collapse whitespace/underscores to a dash
		.replace(/^-+|-+$/g, ''); // trim leading/trailing dashes
};

export default slugify;
